{
  "createProfile": {
    "title": "Complete Your Profile",
    "description": "Please complete your profile to get started with the platform",
    "avatar": "Profile Picture",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "gender": "Gender",
    "man": "Man",
    "woman": "Woman",
    "other": "Other",
    "practitionerType": "Practitioner Type",
    "practitioner": "Practitioner",
    "institution": "Institution",
    "institutionDetails": "Institution Details",
    "institutionAvatar": "Institution Logo",
    "institutionName": "Institution Name",
    "country": "Country",
    "state": "State",
    "city": "City",
    "zipCode": "Zip Code",
    "address": "Address",
    "companyRegistration": "Company Registration",
    "invoicingDetails": "Invoicing Details",
    "company": "Company",
    "createProfile": "Create Profile",
    "invalidFile": "Invalid file",
    "avatarPreview": "Avatar preview",
    "institutionAvatarPreview": "Institution avatar preview",
    "imageHint": "PNG or JPEG, max 2MB",
    "healthDataConsent": {
      "title": "Health Data Processing Consent",
      "description": "In accordance with Article 9 of the GDPR, the processing of health data requires your explicit consent. The health data collected (clinical evaluations, medical histories, diagnostic conclusions) is processed solely within the scope of your professional activity.",
      "label": "I consent to the processing of my health data and that of my patients for the purpose of clinical evaluations"
    }
  },
  "invitation": {
    "welcome": {
      "title": "Invitation to join {{institutionName}}",
      "description": "You have been invited to join {{institutionName}} on MetaDevProfile",
      "institutionLabel": "Institution",
      "continue": "Continue"
    },
    "setPassword": {
      "title": "Set your password",
      "description": "Choose a secure password for your account",
      "password": "Password",
      "confirmPassword": "Confirm password",
      "passwordMinLength": "At least 6 characters",
      "passwordsMatch": "Passwords must match",
      "continue": "Continue",
      "back": "Back"
    },
    "completeProfile": {
      "title": "Complete your profile",
      "description": "A few additional details to finalize your account",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "gender": "Gender",
      "genderOptions": {
        "MAN": "Man",
        "WOMAN": "Woman",
        "OTHER": "Other"
      },
      "complete": "Complete",
      "back": "Back"
    },
    "success": {
      "title": "Welcome to {{institutionName}}!",
      "description": "Your account has been created successfully. You can now access MetaDevProfile.",
      "goToDashboard": "Go to dashboard"
    },
    "errors": {
      "invitationNotFound": "Invitation not found",
      "invitationExpired": "This invitation has expired",
      "invitationAlreadyAccepted": "This invitation has already been accepted",
      "invalidPassword": "Invalid password",
      "passwordMismatch": "Passwords do not match",
      "profileError": "Error creating profile"
    }
  }
}
